import gsap from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export const para = (): void => {
  const paraBgs = document.querySelectorAll('.c-para-bg');
  const paraAnimConts = document.querySelectorAll('.c-anim-cont');
  paraBgs.forEach((paraBg) => {
    gsap.to(paraBg.querySelector('.c-para-bg__bg'), {
      top: '0%',
      scrollTrigger: {
        trigger: paraBg,
        start: 'top 100%',
        end: 'bottom 0%',
        scrub: true,
      },
    });
  });
  paraAnimConts.forEach((paraAnimCont) => {});
};
